<ng-container *ngFor="let unit of units">

    <div *ngIf="unit?.type !== 'COURSE_UNIT_PART'">

        <div [ngClass]="{'study-module': unit.type === 'STUDY_MODULE', 'programme-item offering': unit.type === 'OFFERING',
        'category': unit.type === 'CATEGORY', 'programme-item course-unit': unit.type === 'COURSE_UNIT'}">

            <div class="programme-item" [ngClass]="{'study-module-item': unit.type === 'STUDY_MODULE', 'offering-item': unit.type === 'OFFERING',
            'category-item': unit.type === 'CATEGORY', 'course-unit-item': unit.type === 'COURSE_UNIT'}">

                <div class="programme-item-elem" [ngClass]="{'study-module-item': unit.type === 'STUDY_MODULE', 'offering-item': unit.type === 'OFFERING',
                'category-item': unit.type === 'CATEGORY', 'course-unit-item': unit.type === 'COURSE_UNIT'}">
                    <a *ngIf="unit?.type === 'STUDY_MODULE'" routerLink="/{{globals.lang}}/{{globals.getLocalizedStudyModule()}}/{{unit?.code}}/{{unit?.id}}" [queryParams]="{period: period}">{{globals.getLocalizedValueForTitle(unit.name)}}</a>
                    <a *ngIf="unit?.type === 'CATEGORY'" routerLink="/{{globals.lang}}/{{globals.getLocalizedCategory()}}/{{unit?.code}}/{{unit?.id}}" [queryParams]="{period: period}">{{globals.getLocalizedValueForTitle(unit.name)}}</a>
                    <a *ngIf="unit?.type === 'OFFERING' && !unit?.root" routerLink="/{{globals.lang}}/{{globals.getLocalizedOffering()}}/{{unit?.code}}/{{unit?.id}}" [queryParams]="{period: period}">{{globals.getLocalizedValueForTitle(unit.name)}}</a>
                    <span *ngIf="unit?.type === 'OFFERING' && unit?.root">{{globals.getLocalizedValueForTitle(unit.name)}}</span>
                    <a *ngIf="unit?.type === 'COURSE_UNIT'" routerLink="/{{globals.lang}}/{{globals.getLocalizedCourse()}}/{{unit?.code}}/{{unit?.id}}" [queryParams]="{period: period}">{{globals.getLocalizedValueForTitle(unit.name)}}</a>
                    
                    <span class="teached-in-english" *ngIf="globals.lang==='en' && unit?.teachedInEnglish">(in English)</span>
                </div>

                <div class="programme-item-elem" [ngClass]="{'study-module-centered': unit.type === 'STUDY_MODULE', 'offering-centered': unit.type === 'OFFERING',
                'category-centered': unit.type === 'CATEGORY', 'course-unit-centered': unit.type === 'COURSE_UNIT'}">
                    <span *ngIf="unit.maxCredits>unit.minCredits">{{unit.minCredits}}-{{unit.maxCredits}}</span>
                    <span *ngIf="unit.maxCredits==unit.minCredits">{{unit.minCredits}}</span>
                </div>

            </div>
            <structure-unit [unit]="unit.children" [period]="this.period"></structure-unit>

        </div>

    </div>

</ng-container>
